.value {
    font-size: 18px;
    line-height: 18px;
    margin-left: 5px;
    margin-right: 5px;
}
